var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('login-modal',{attrs:{"show":_vm.showModal,"redirect":"checkout"},on:{"close":_vm.close}},[_c('div',{staticClass:"alert alert-warning"},[_c('strong',[_vm._v("You've been logged out.")]),_c('br'),_vm._v(" "),_c('p',[_vm._v("You will be taken back to the basket page to check your order after you log back in.")])])])],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ff6bc20","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/Components/Elements/LoginChecker.vue
// module id = 3+vZ
// module chunks = 0